var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800"},[_vm._v("\n    "+_vm._s(_vm.item.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }